import APIconsume from 'Main/APIconsume'

const BASE_URL = '/api/dashboard/inquiry-configs'

class InquiryConfigService {
  constructor () {
    this._apiConsume = new APIconsume()
  }

  /** GET /vendors/Inquiry-configs */
  async getData () {
    const result = await this._apiConsume.getData(BASE_URL)
    return result?.data
  }

  /** GET /vendors/Inquiry-configs/:id: used by the Edit flow (viewQrisConfig in the ejs). */
  async getById (id) {
    const result = await this._apiConsume.getData(`${BASE_URL}/${id}`)
    return result?.data
  }

  /** POST /vendors/Inquiry-configs */
  async create (payload) {
    const result = await this._apiConsume.postData(payload, BASE_URL)
    return result?.data
  }

  /** PUT /vendors/Inquiry-configs/:id */
  async update (id, payload) {
    const result = await this._apiConsume.putData(payload, `${BASE_URL}/${id}`)
    return result?.data
  }

  /** DELETE /vendors/Inquiry-configs/:id */
  async deleteById (id) {
    const result = await this._apiConsume.deleteData(`${BASE_URL}/${id}`)
    return result?.data
  }

  async getPaymentVendors () {
    const result = await this._apiConsume.getData('/api/dashboard/payment-vendors')
    return result?.data
  }
}

export default InquiryConfigService
